import React, { useState, useMemo, useEffect } from 'react';
import { Layout as AntLayout, Menu, Select } from 'antd';
import { LogoIcon } from 'icons';
import styles from './style.module.scss';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import useUser, { getPages } from 'hooks/useUser';
import { useRecoilValue } from 'recoil';
import LinkWithParams from '../../linkWithParams';
import { HomeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Sider } = AntLayout;
const { Option } = Select;

const Sidebar = () => {
  const { t } = useTranslation();
  const { setCurrentPage } = useUser();
  const pages = useRecoilValue(getPages);
  const { pathname = '' } = useLocation();
  const navigate = useNavigate();
  function handleChange(value) {
    navigate(value);
  }
  const currentPage = useMemo(
    () =>
      pages.find((i) => {
        return (pathname + '/').includes(i.basePath + '/');
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname, pages],
  );

  let currentSubMenuValue = useMemo(
    () => currentPage?.subLinks?.find((i) => pathname.includes(i.link)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname, pages],
  );
  useEffect(() => {
    return () => {
      setCurrentPage(currentSubMenuValue || {});
    };
  }, [currentSubMenuValue]);
  return (
    <Sider className={styles.sideBar} width={'244px'}>
      <div className={styles.logo}>
        <Link to={'/'}>
          <LogoIcon />
        </Link>
      </div>
      <div className={styles.topSelectWrapper}>
        <Select
          bordered={false}
          className={styles.topSelect}
          dropdownClassName={styles.topSelect_dropdown}
          onChange={handleChange}
          virtual={false}
          listHeight={500}
          value={currentPage?.link}
        >
          {pages.map((i, index) => (
            <Option
              className={styles.menuItem}
              value={i.link}
              key={index}
              data={i}
            >
              <i.Icon width={'16px'} height={'16px'} fill={'#568CA3'} />
              {i.title}
            </Option>
          ))}
        </Select>
      </div>
      <Menu
        className={styles.menu}
        mode='inline'
        selectedKeys={[
          pathname.includes('new')
            ? '/boarddocs/weekly/new'
            : currentSubMenuValue?.link || currentPage?.link
        ]}
        defaultSelectedKeys={['4']}
      >
        <Menu.Item
          style={{ whiteSpace: 'normal', height: 'auto' }}
          className={styles.link}
        >
          <HomeOutlined className={styles.homeIcon} />
          <Link to={'/'}>{t('Home')}</Link>
        </Menu.Item>
        {!currentPage?.hideMain && (
          <Menu.Item className={styles.link} key={currentPage?.link}>
            <Link to={currentPage?.link || '#'}>{currentPage?.main}</Link>
          </Menu.Item>
        )}
        {currentPage?.subLinks?.map((i) => {
          const otherProps = {};
          if (i.openNewTab) {
            otherProps.onClick = (e) => {
              e.preventDefault();
              window.open(i.link);
            };
          }
          let LinkComponent = Link;

          if (i.withParams) {
            LinkComponent = LinkWithParams;
          }

          return (
            <Menu.Item className={styles.link} key={i.link}>
              <LinkComponent {...otherProps} to={i.link}>
                {i.title}
              </LinkComponent>
            </Menu.Item>
          );
        })}
      </Menu>
    </Sider>
  );
};

export default React.memo(Sidebar);
